import React from 'react';
import Spinner from './Spinner';
import './LoadingOverlay.css';

/*
 * LoadingOverlay — absolutely-positioned panel loader. Drop inside any
 * position:relative container (a Card, a table-wrap) to veil it while loading.
 *   show   : when false renders nothing
 *   label  : optional text under the spinner
 *   size   : spinner diameter (px)
 *   blur   : soften the veiled content behind the scrim
 * The parent must be position:relative (or use `fixed` for a full-viewport veil).
 */
export default function LoadingOverlay({
  show = true,
  label,
  size = 26,
  blur = false,
  fixed = false,
  className = '',
  ...rest
}) {
  if (!show) return null;
  const cls = [
    'ui-overlay',
    fixed ? 'ui-overlay--fixed' : '',
    blur ? 'ui-overlay--blur' : '',
    className,
  ].filter(Boolean).join(' ');
  return (
    <div className={cls} role="status" aria-live="polite" {...rest}>
      <div className="ui-overlay__box">
        <Spinner size={size} label={label || 'Loading'} />
        {label != null && <div className="ui-overlay__label">{label}</div>}
      </div>
    </div>
  );
}
